/* eslint-disable react-hooks/exhaustive-deps */
import { Button, List, Modal, Skeleton } from 'antd';
import {
  useAppDispatch,
  useAppNavigation,
  useAuthState,
  useBusinessState,
  useModalState,
} from '@core/.';
import { closeModal } from '@core/features';
import ContainerCard from '../ContainerCard';
import { selectLocation } from '@core/features/business/thunks/selectLocation.thunk';
import { Location } from '@core/models';
import { CheckCircleOutlined } from '@ant-design/icons';

type Props = {};

const SelectLocationModal = (_: Props) => {
  const dispatch = useAppDispatch();
  const { navigate } = useAppNavigation();
  const { user } = useAuthState();
  const { locationModal } = useModalState();
  const { locations, isLoading } = useBusinessState();

  const onSelectLocation = async (locationName: string) => {
    try {
      await dispatch(selectLocation(locationName));
      navigate('home');
      handleCloseModal();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseModal = () => {
    dispatch(
      closeModal({
        modalName: 'locationModal',
      })
    );
  };

  const renderDescription = (item: Location) => {
    return `${item?.storefrontAddress?.addressLines?.[0]}, ${item.storefrontAddress?.locality}, ${item.storefrontAddress?.regionCode}`;
  };

  return (
    <Modal
      title="Select your location"
      centered
      open={locationModal}
      onOk={handleCloseModal}
      onCancel={handleCloseModal}
      width={1000}>
      <ContainerCard style={{ minHeight: 'fit-content' }}>
        {isLoading ? (
          <Skeleton />
        ) : (
          <div>
            <i>
              <a href="/#/app/instruction">Don't see your location? Follow this guide.</a>
            </i>
            <List
              style={{ marginTop: 20 }}
              dataSource={locations}
              pagination={{
                onChange: page => {
                  console.log(page);
                },
                hideOnSinglePage: true,
                pageSize: 5,
              }}
              renderItem={(item, index) => (
                <List.Item
                  key={item.name}
                  actions={[
                    !!user && user.selected_location?.title !== item?.title ? (
                      <Button
                        type="primary"
                        shape="round"
                        onClick={() => onSelectLocation(item.name)}>
                        Select
                      </Button>
                    ) : (
                      <CheckCircleOutlined style={{ fontSize: 20 }} />
                    ),
                  ]}>
                  <List.Item.Meta
                    title={<p>{item.title}</p>}
                    description={renderDescription(item)}
                  />
                </List.Item>
              )}
            />
          </div>
        )}
      </ContainerCard>
    </Modal>
  );
};

export default SelectLocationModal;
